export default __webpack_public_path__ + "static/media/training.4524e855.png";